<template>
  <div>
    <div class="main" v-if="!recordHasDelete && info.title">
      <!-- <div class="title">{{info.title}}</div> -->
      <div v-html='info.content'></div>
      <!-- <div class="desc">阅读：{{simplify(info.viewCounts, 2)}}</div> -->
      <div class="footer">
        <a class="btn clear_normal" href="tel:400-004-0686">
          <img class="icon" src="../assets/img/icon-service@3x.png" alt="icon" />
          联系客服
        </a>
        <!-- <div class="btn">
          <img class="icon" src="../assets/img/icon-msg@3x.png" alt="icon" />
          反馈建议
        </div> -->
      </div>
    </div>
    <div class="page" v-if="recordHasDelete">
      <div class="none">
        <img class="image" src="../assets/img/help_text_not_find@3x.png" alt="icon" />
        <div class='desc'>文章丢失了</div>
      </div>
    </div>
  </div>
</template>

<script>
import req from '../req';

export default {
  name: 'help_instruction',
  data() {
    return {
      info: {},
      recordHasDelete: false,
    };
  },
  created() {
    const { sessionId } = this.$route.query;
    this.getDetail();
    if (sessionId) {
      this.saveHelpNoteTimesWhenClick();
    }
  },
  methods: {
    getApiRes(api) {
      const { helpNumber, sessionId } = this.$route.query;
      return new Promise((res, rej) => {
        req.sys[api]({
          helpNumber,
        }, sessionId ? {
          headers: {
            sessionId,
          },
        } : {})
          .then((r1) => {
            if (r1.code !== 0) {
              rej(r1);
              return;
            }
            res(r1);
          })
          .catch(rej);
      });
    },
    getDetail() {
      const that = this;
      this.getApiRes('getHelpTextDetail')
        .then((res) => {
          if (res.code === 4920) {
            that.recordHasDelete = true;
            return;
          }
          if (res.code !== 0) {
            req.err.show(res.msg);
            return;
          }
          that.info = res.data;
        })
        .catch((err) => {
          req.err.show(err);
        });
    },
    saveHelpNoteTimesWhenClick() {
      this.getApiRes('saveHelpNoteTimesWhenClick')
        .then((res) => {
          if (res.code !== 0) {
            req.err.show(res.msg);
          }
        })
        .catch((err) => {
          req.err.show(err);
        });
    },
    /**
     * 数字简化
     */
    simplify(n, fixed, unit) {
      const that = this;
      if (!n && n !== 0) {
        return 0;
      }
      if (!fixed && fixed !== 0) {
        return n;
      }
      let res = n - 0;
      switch (unit) {
        case 'k':
          if (n >= 1000) {
            res = (res / 1000).toFixed(fixed) - 0 + unit;
          } else {
            res = res.toFixed(fixed) - 0;
          }
          break;
        case 'w':
          if (n >= 10000) {
            res = (res / 10000).toFixed(fixed) - 0 + unit;
          } else {
            res = res.toFixed(fixed) - 0;
          }
          break;
        default:
          res = that.simplify(n, fixed, n >= 10000 ? 'w' : 'k');
          break;
      }
      return res;
    },
  },
};
</script>

<style lang="scss" scoped>
  .main {
    padding: 20px;
    @media screen and (min-width: 1024px) {
      max-width: 677px;
      margin: 0 auto;
    }

    .title {
      margin-bottom: 20px;
      font-size: 20px;
      font-weight: 500;
      color: #212732;
    }
    .content {
    }
    .desc {
      font-size: 14px;
      color: #858b96;
    }
    .footer {
      margin-top: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 129px;
      height: 42px;
      line-height: 42px;
      text-align: center;
      border-radius: 8px;
      border: solid 1px #367fee;
      font-size: 16px;
      color: #367fee;
      margin-right: 20px;
    }
    .footer .btn:last-child {
      margin-right: 0;
    }
    .btn .icon {
      width: 30px;
      height: 30px;
    }
    .clear_normal {
      text-decoration: none;
    }
  }
  .page {
    height: 100vh;
    width: 100%;
    background-color: #f3f3f7;
    .none {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 100%;
      height: 282px;
      background-color: #ffffff;
      .image {
        width: 225px;
        height: 110px;
      }
      .desc {
        font-size: 14px;
        color: #858b96,
      }
    }
  }
</style>
